import { resetUrlParams } from 'common/utils';

export default {
  props: {
    // 筛选列表
    filterList: {
      default: () => [],
      type: Array,
    },
    total: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      langContext: this.$t('featureComponents.CoursesFilters'),
      curIndex: -1, // 选中前四项筛选项 索引
      curYear: new Date().getFullYear(), // 当前年份（学年默认选中当年 / 无学年学期淘汰判断）
    }
  },
  created() {
    this.init()
    this.changeFilterUrl()
    this.sendUpdateFilter()
  },
  mounted() {
    this.getSpecialParams()
  },
  methods: {
    // 筛选项数据格式化
    getFilterData() {
      this.filterList.forEach((item) => {
        const isYear = item.type === 'year'
        const tempArr = [{
          name: this.langContext.all,
          key: -1,
          value: -1,
          disable: false,
          selected: !isYear, // 学年筛选默认不选「全部」，默认选中当年
        }]
        item.value.forEach((item1) => {
          const temp = {
            name: this.setUsFilterName(item, item1),
            value: item1.key,
            key: item1.key,
            academicYear: item1.academicYear,
            disable: false,
            selected: isYear ? item1.key === this.curYear : false, // 学年默认选中当年
          }
          if (item.type === 'difficulty') {
            temp.color = '#222'
          }
          tempArr.push(temp)
        })
        this.filtersData.push({
          filterName: item.name,
          filterType: item.type,
          hidden: false,
          dataList: tempArr,
        })
        if (item.type === 'term') {
          this.termAllDataList = tempArr
        }
      })
    },
    // 美分校 && 火星 学期晒选项显示值修改
    setUsFilterName(item, item1) {
      if ((this.$store.state.locale === 'us' || this.$store.state.locale === 'cn') && item.type === 'term' && item1.name === 'Summer') {
        return 'Summer（TermA）'
      }
      return item1.name
    },
    // 从url参数中获取筛选项
    getUrlFilter() {
      const curQurey = this.$route.query
      const tempList = Object.keys(curQurey).map((key) => ({
        type: key,
        value: curQurey[key],
      }))
      return tempList
    },
    // 获取当前选中筛选项
    getSeletedFilter() {
      const filters = this.filtersData.filter((items) => !items.dataList[0].selected).map((item) => {
        const keysList = item.dataList.filter((item1) => item1.selected).map((item2) => item2.key)
        return {
          type: item.filterType,
          keysList,
        }
      })
      return filters
    },
    // 非筛选项参数
    getSpecialParams() {
      const tempList = this.getUrlFilter()
      this.urlSpecialParams = tempList.filter((item) => !this.filtersData.some((item1) => item1.filterType === item.type))
    },
    // 获取筛选参数
    getChangeFilter() {
      const queryList = []
      const list = this.getSeletedFilter()
      list.forEach((item) => {
        queryList.push({
          type: item.type,
          keys: item.keysList,
        })
      })
      return queryList
    },
    // 获取一级索引
    getParentIndex(type) {
      return this.filtersData.findIndex((item) => item.filterType === type)
    },
    // 按 type 获取筛选对象
    getFilterByType(type) {
      return this.filtersData.find((item) => item.filterType === type)
    },
    // 获取当前选中的学年（key !== -1 表示非「全部」）
    getSelectedYear() {
      const yearFilter = this.getFilterByType('year')
      if (!yearFilter) return null
      const selected = yearFilter.dataList.find((item) => item.selected && item.key !== -1)
      return selected ? selected.value : null
    },
    // 学年↔学期联动：选学年 → 学期只显示该学年；未选学年 → 隐藏学期
    applyYearTermLinkage() {
      const termFilter = this.getFilterByType('term')
      if (!termFilter) return
      const selectedYear = this.getSelectedYear()
      const fullList = this.termAllDataList && this.termAllDataList.length ? this.termAllDataList : termFilter.dataList
      if (selectedYear == null) {
        termFilter.hidden = true
        termFilter.dataList = fullList
        termFilter.dataList.forEach((item, index) => {
          termFilter.dataList[index].selected = index === 0
        })
      } else {
        termFilter.hidden = false
        const selectedYearNum = Number(selectedYear)
        const matched = [fullList[0], ...fullList.slice(1).filter((item) => {
          // 有学年：按选中学年匹配；无学年：仅在选中 2027 之前（不含）的学年时展示
          if (item.academicYear != null && item.academicYear !== '') {
            return String(item.academicYear) === String(selectedYear)
          }
          return selectedYearNum < 2027
        })]
        const hasSelected = matched.slice(1).some((item) => item.selected)
        if (!hasSelected) {
          matched.forEach((item, index) => {
            matched[index].selected = index === 0
          })
        }
        termFilter.dataList = matched
      }
    },
    // url参数修改状态
    changeFilterUrl() {
      const tempList = this.getUrlFilter()
      const filterParamList = tempList.filter((item) => this.filtersData.some((item1) => item1.filterType === item.type)).filter((item2) => item2.value)
      filterParamList.forEach((item) => {
        const index = this.filtersData.findIndex((filterItem) => filterItem.filterType === item.type)
        // url 参数重复时 vue-router 解析为数组，归一化为多选语义再拆分
        const valueStr = Array.isArray(item.value) ? item.value.join('_') : item.value
        const splitArr = valueStr.split('_')
        splitArr.forEach((splitItem) => {
          const index1 = this.filtersData[index].dataList.findIndex((item1) => item1.key === +splitItem)
          if (index1 === -1) return
          if (this.filtersData[index].filterType === 'year') {
            // 学年单选：恢复前清空，避免与默认当年并存
            const yearDataList = this.filtersData[index].dataList
            for (let i = 0; i < yearDataList.length; i += 1) {
              yearDataList[i].selected = false
            }
          }
          this.filtersData[index].dataList[index1].selected = true
          this.filtersData[index].dataList[0].selected = false
          if (this.filtersData[index].filterType === 'difficulty') {
            this.changeRateColor(this.filtersData[index].dataList[index1], index1, index)
          }
        })
        // touch端
        if (this.headersList && this.headersList.length) this.changeHeaderList(item.type)
      })
      this.applyYearTermLinkage()
    },
    // 困难类型五角星 颜色
    changeRateColor(item, index, parentIndex, isHover = false) {
      this.filtersData[parentIndex].dataList[index].color = item.selected || isHover ? '#ffaa0a' : '#222'
    },
    // emit 筛选项列表(点击)
    sendChangeFilter() {
      const queryList = this.getChangeFilter()
      this.$emit('change', queryList)
    },
    // emit 筛选项列表(点击)
    sendUpdateFilter() {
      const queryList = this.getChangeFilter()
      this.$emit('update', queryList)
    },
    // 更新路由参数
    updateHistoryParams() {
      const urlList = []
      const list = this.getSeletedFilter()
      list.forEach((item) => {
        urlList.push({ [item.type]: item.keysList.join('_') })
      })
      const specialList = this.urlSpecialParams.map((item) => ({ [item.type]: item.value }))
      if (!urlList.length && !specialList.length) {
        window.history.replaceState({}, '', window.location.pathname)
      } else {
        resetUrlParams(Object.assign({}, ...urlList, ...specialList), false)
      }
    },
    // 重置所有筛选项
    handleAllReset() {
      this.filtersData.forEach((item, index) => {
        const isYear = item.filterType === 'year'
        item.dataList.forEach((item1, index1) => {
          if (isYear) {
            // 学年重置为默认选中当年
            this.filtersData[index].dataList[index1].selected = item1.key === this.curYear
          } else {
            this.filtersData[index].dataList[index1].selected = index1 === 0
          }
          if (item.filterType === 'difficulty') this.changeRateColor(item1, index1, index)
        })
      })
      this.applyYearTermLinkage()
      this.updateHistoryParams()
      this.sendChangeFilter()
      this.handleResetTrack()
    },
    // 点击展开/收起按钮埋点上报
    handleMoreTrack(isMore) {
      this.Sensors.track('courses_list_stretch_click', {
        type: isMore ? 'open' : 'retract',
      })
    },
    // 点击重置按钮埋点上报
    handleResetTrack() {
      this.Sensors.track('courses_list_reset_click')
    },
  },
}
